import { ENTER } from '@angular/cdk/keycodes';
import { Component, Input, OnChanges, Output, SimpleChanges, EventEmitter, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject, of } from 'rxjs';
import { debounceTime, switchMap, catchError } from 'rxjs/operators';
import { CommonModelService } from '../../../../../padu-reporting/capability/common-model.service';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
import { DropdownWithSearchComponent } from '../../../../../shared/elements/dropdown-with-search/dropdown-with-search.component';
import { MatFormField, MatOption } from '@angular/material/select';
import { MatChipGrid, MatChipInput } from '@angular/material/chips';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MaintenanceTableV4Component } from '../../../maintenance-table-v4/maintenance-table-v4.component';
import { LoaderComponent } from '../../../../../shared/elements/loader/loader.component';

@Component({
    selector: 'app-add-edit-forecast-role-management',
    templateUrl: './add-edit-forecast-role-management.component.html',
    styleUrl: './add-edit-forecast-role-management.component.css',
    imports: [DropdownWithSearchComponent, MatFormField, MatChipGrid, MatInput, MatAutocompleteTrigger, MatChipInput, MatAutocomplete, MatOption, MaintenanceTableV4Component, LoaderComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class AddEditForecastRoleManagementComponent implements OnChanges {

  @Input() segmentData: any = [];
  @Input() actionType: string = 'Add';
  @Input() editData: any = null;
  @Output() refreshParentTable: EventEmitter<any> = new EventEmitter<any>();
  @Input() allForecastRoleData: any = [];
  dataSourceDetails:MatTableDataSource<any> = new MatTableDataSource([]);
  segmentArray: any = [];
  forecastRoleList: any = [];
  segmentPlaceholder: string = 'Select Segment';
  forecastRolePlaceholder: string = 'Select Role';
  userPlaceholder: string = 'Select User';
  selectedRole: any;
  selectedSegmentArr: any = [];
  separatorKeysCodes: number[] = [ENTER];
  searchUser: any;
  subject = new Subject<string>();
  searchUserList: any = [];
  selectedRemoveUserlist: any = [];
  existingUser: any = [];
  allUserData: any = [];
  isTableRefreshed: boolean = false;
  disableDD: boolean = false;
  isSubmitButtonDisabled: boolean = true;
  payloadData: any = {
    add: [],
    remove: []
  };
  TABLE_COLUMNS: any = [
    {
      matColumnDef: 'select',
      key: 'select',
      labelKey: "",
      label: ''
    },
    {
      key: 'displayName',
      labelKey: "displayName",
      label: 'Name',
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'mail',
      labelKey: "mail",
      label: 'E-mail',
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'MSID',
      labelKey: "MSID",
      label: 'MSID',
      filter: false,
      align: 'left',
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }],
      padding: '5px 15px 5px 5px !important'
    },
    {
      key: 'Actions',
      labelKey: "Actions",
      label: '',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      width: '1% !important',
      edit: false,
      validations: [{ 'required': false }],
    }

  ]
  TABLE_CONFIG: any = {
    pageSize: [5, 10, 15],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    TABLE_CLASS : ''
  };
  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  showLoader: boolean = false;

  constructor(private toasterService: ToastrService, private commonModalService: CommonModelService,private maintenanceService: MaintenanceService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.clearData();//Initialise the data with default values
    this.convertSegmentDataIntoArray(this.segmentData); 
    this.initialiseRoleList();
    this.initialiseData();//Initialise the data
  }

  // This method will convert the segment data into array of segment names
  convertSegmentDataIntoArray(data){
    this.segmentArray = data.map((item) => {return {'name': item.Master_Billing_Segment}});
  }

  // This method will initialise the role list
  initialiseRoleList(){
    this.forecastRoleList = [
      {name: 'Forecast Admin', value: 'Forecast_Admin'},
      {name: 'Forecast Admin Viewer', value: 'Forecast_Admin_Viewer'},
      {name: 'SRM', value: 'SRM'},
      {name: 'SRM Viewer', value: 'SRM_Viewer'},
    ];
  }

  //Function to clear the data
  clearData(){
    this.selectedRole = null;
    this.selectedSegmentArr = [];
    this.searchUser = null;
    this.searchUserList = [];
    this.dataSourceDetails = new MatTableDataSource([]);
    this.isSubmitButtonDisabled = true;
    this.payloadData = {
      add: [],
      remove: []
    };
    this.selectedRemoveUserlist = [];
    this.isTableRefreshed = false;
    this.disableDD = false;
    this.allUserData = [];
  }

  initialiseData(){
    if(this.actionType == 'Edit' && this.editData != null){
      this.bindDataForEdit();
    }
    this.setUpSubject();//Set up the subject for the search user 
  }

  //Function to bind data on which edit is clicked
  bindDataForEdit(){
    this.existingUser = this.editData.Users;
    if (this.editData.Master_Segment == 'All') {
      this.selectedSegmentArr = this.segmentArray;
    } else {
      const index = this.segmentArray.findIndex((item) => item.name == this.editData.Master_Segment);
      this.selectedSegmentArr = [this.segmentArray[index]];
    }
    this.selectedRole = this.forecastRoleList[this.getRoleIndex(this.editData.User_Role)];
    this.allUserData = [];
    this.createDataSource(this.existingUser);
  }

  //Function to get the index of the role in-order to bind for edit
  getRoleIndex(val){
    return this.forecastRoleList.findIndex((item) => item.value == val);
  }

  //Function to set the selected segment data in array
  setSelectedSegmentArr(event){
    this.selectedSegmentArr = event.data;
    this.getAllUserData();
  }

  // Function to retrieve all user data based on selected segments and roles
  getAllUserData(){
    this.allUserData = [];
    this.selectedSegmentArr.forEach((item) => {
      const data = this.getForecastRoleData(item.name, this.selectedRole.value);
      this.allUserData = [...this.allUserData, ...data];
    });
  }

  //Function to set selected role value
  //If the role is Forecast_Admin or Forecast_Admin_Viewer then disable the segment dropdown
  setSelectedRoleValue(event){
    this.selectedRole = event.data;
    this.allUserData = [];
    if(this.selectedRole.value == 'Forecast_Admin' || this.selectedRole.value == 'Forecast_Admin_Viewer'){
      this.disableDD = true;
      if(this.actionType == 'Add'){
        this.selectedSegmentArr = this.segmentArray;
      }
      this.allUserData = this.getForecastRoleData('All', this.selectedRole.value);
    }
    else{
      this.disableDD = false;
      this.selectedSegmentArr = [];
    }
    this.handleRoleChangeAction();
  } 

  //Function to handle the role change action
  handleRoleChangeAction(){
    if(this.searchUser && this.searchUser.target.value){
      this.searchUser.target.value = '';
      this.searchUserList = [];
    }
    this.createDataSource([]); //update the table
  }

   // Load User data into the table
   public onSearchUser(ev) {
    this.searchUser = ev;
    if (this.searchUser.target.value.length >= 4) {
      this.subject.next(this.searchUser.target.value);
    }
  }

  // Get the searched user from the LDAP API
  getSearchedUser() {
    return this.commonModalService.getLDAPUsers(this.searchUser.target.value);
  }

  //Function to set up the subject for the search user
  setUpSubject() {
    this.subject.pipe(
      debounceTime(300),
      // distinctUntilChanged(),
      switchMap(() => this.getSearchedUser().pipe(
        catchError(error => {
          this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          return of([]);
        })
      ))
    ).subscribe((users) => {
      this.disableExistingUsers(users);
    },
      error => {
        // Handle error scenario
        this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      });
  }

  //disable already added users
  disableExistingUsers(dataStream: Array<any>) {
    let existingEmails = new Set();
      const tableData = this.dataSourceDetails.data.map(user => user.mail);
      const filterData = this.allUserData.map(item => item.mail); //data based on filter from role and segment
      existingEmails = new Set([...tableData, ...filterData]);
      dataStream.forEach(item => {
      // Disable the item if the email is undefined or already exists in the set
      if (item.mail == undefined || existingEmails.has(item.mail)) {
        item.disable = true;
      } else {
        item.disable = false;
      }
    });
    this.searchUserList = dataStream;
  }

  //Function to handle the selected user
  getSelectedUsers(event) {
    this.onAddUser(event.option.value);
  }

  //Function to handle checkbox click event
  checkboxClick(event) {
    this.selectedRemoveUserlist = event.data;
    if (this.isTableRefreshed) {
      this.isTableRefreshed = false;
    }
  }

  //Function to add user into list 
  onAddUser(user) {
    user['MSID'] = user.cn;
    let isExistingUser = false;
    if (this.actionType == 'Edit' && this.existingUser.length > 0) {
      const data = this.replaceDataForExistingtUser(user,this.existingUser, 'MSID');
      if(data){
        isExistingUser = true;
        user = data;
      }
    }
    if(!isExistingUser){
      user['isNewUser'] = true;
    } 
    const newList = this.dataSourceDetails?.data;
    newList.push(user);
    this.createDataSource(newList); //update the table
    this.clearDataForAddUser();
    this.getUpdatedValues();
  }

  //Function to replace the data for existing user
  replaceDataForExistingtUser(obj, arr2, key) {
    const data =  arr2.find((item) => {
      if (obj[key] === item[key]) {
        return item;
      }
    });
    return data;
  }

  //Function to create data source for the table
  createDataSource(data) {
    this.dataSourceDetails = new MatTableDataSource(data);
  }

  //Function to clear the data after adding the user
  clearDataForAddUser() {
    this.searchUserList = [];
    this.isTableRefreshed = true;
    this.searchUser.target.value = '';
  }

  //Function to get the updated values after performing some action
  getUpdatedValues() {
    const obj = {add: [], remove: []};
    obj.add = this.dataSourceDetails.data.filter(item => item.isNewUser);
    if(this.actionType == 'Edit'){
      obj.remove = this.filterArray(this.existingUser, this.dataSourceDetails.data, 'MSID');
    }
    this.payloadData = obj;
    this.isSubmitButtonDisabled = !this.checkForChanges();
  }

  //Function to remove user from list 
  onRemoveUser() {
    const filterArray = this.filterArray(this.dataSourceDetails.data, this.selectedRemoveUserlist, 'mail');
    this.createDataSource(filterArray); //update the table
    this.clearDataAfterRemoveUser();
  }

  clearDataAfterRemoveUser(){
    this.searchUserList = [];
    this.selectedRemoveUserlist = [];
    this.isTableRefreshed = true;
    this.getUpdatedValues();
  }

  //Function to filter the array based on the key
  filterArray(array1, array2, key1) {
    const array2Ids = new Set(array2.map(item => item[key1]));
    return array1.filter(item => !array2Ids.has(item[key1]));
  }

  //Function to handle the submit button click
  onSubmitForm(){
    const payload = this.createPayload();
    this.showLoader = true;
    if(this.actionType == 'Add'){
      this.maintenanceService.addInfraForecastOwnerAccess(payload).subscribe((res) => {
        this.handleSuccess(res,'Data Added Successfully');
      }, (error) => {
        this.handleErrors(error);
      });
    }else if(this.actionType == 'Edit'){
      this.maintenanceService.updateInfraForecastOwnerAccess(payload).subscribe((res) => {
        this.handleSuccess(res,'Data Updated Successfully');
      }, (error) => {
        this.handleErrors(error);
      });
    }
  }

  //Function to handle the success after API call
  handleSuccess(res,msg){
    this.toasterService.success(msg, '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'});
    this.showLoader = false;
    this.refreshParentTable.emit(res);
    this.clearData();
  }

  //Function to handle the errors after API call
  handleErrors(error: any) {
    console.error('An error occurred:', error);
    const errorMessage = error.statusText || 'An unexpected error occurred';
    this.showLoader = false;
    this.toasterService.error(errorMessage, '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }

  //Function to create payload
  createPayload(){
    const payload = {
      "Master_Segment": [],
      "User_Role" :"",
      "add":[],
      "remove":[]
    }
    if(this.actionType == 'Add'){
      if(this.selectedSegmentArr.length == this.segmentArray.length){
        payload.Master_Segment = this.segmentArray.map((item) => item.name);
      }else{
        payload.Master_Segment = this.selectedSegmentArr.map((item) => item.name);
      }
      payload.User_Role = this.selectedRole.value;
      payload.add = this.payloadData.add;
    }else if(this.actionType == 'Edit'){
      payload.Master_Segment = [this.editData.Master_Segment];
      payload.User_Role = this.selectedRole.value;
      payload.add = this.payloadData.add;
      payload.remove = this.payloadData.remove;
    }
    return payload;
  }

  //Function to check for changes for Submit button disability
  checkForChanges(){
    if(this.actionType == 'Add' && (this.payloadData.add.length > 0)){
      return true;
    }else if(this.actionType == 'Edit' && (this.payloadData.add.length > 0 || this.payloadData.remove.length > 0)){
      return true;
    }
    return false;
  }

  //Function to get the list of users that matches the forecast role and segment
  getForecastRoleData(segment, role){
    const data = this.allForecastRoleData.filter((item) => item.User_Role == role && item.Master_Segment == segment);
    return data.length > 0 ? data[0].Users : [];
  }

}
